import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=1e939b15"
import script from "./statistic.vue?vue&type=script&lang=tsx"
export * from "./statistic.vue?vue&type=script&lang=tsx"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports